import React from "react";
import { Modal } from "react-bootstrap";
import ZoomComponent from "../ZoomComponent";

const ZoomedDocPopup = ({ showPopup, setShowPopup, img }) => {
  console.log(img);
  return (
    <Modal size="lg" show={showPopup} onHide={() => setShowPopup(false)}>
      <Modal.Body
        //className="d-flex align-items-center justify-content-center"
        //style={{ width: 500, height: 500 }}
      >
        <ZoomComponent doc={img} />
        {/* <embed
          src={img.url}
          style={{ overflow: "hidden" }}
          height={500}
          width={500}
          id="zoomed-img"
        /> */}
      </Modal.Body>
    </Modal>
  );
};

export default ZoomedDocPopup;
